<template>
    <div class="used-car-item">
        <UsedCarListItem :item="data" />
        <UsedCarOrderInfo ref="order" :orderid="id" @returnorder="getOrderInfo" />
        <ItemTabs ref="itemTabs" />
    </div>
</template>

<script>
import { 
    NavBar,
    Grid,
    GridItem,
    Image,
    Row,
    Col,
    Icon, 
    Loading, 
    List,
    GoodsAction,
    GoodsActionIcon,
    GoodsActionButton
} from 'vant'

import { UsedCarShopApi } from '@/api/usedcar'
import UsedCarListItem from '@/view/usedcar/components/usedcarlistitem'
import UsedCarOrderInfo from '@/view/usedcar/components/orderinfo'
import ItemTabs from '@/view/usedcar/components/itemtabs'

export default {
    name: 'UsedCarOrderItem',
    components: {
        [NavBar.name]: NavBar,
        [Icon.name]: Icon,
        [Loading.name]: Loading,
        [List.name]: List,
        [Grid.name]: Grid,
        [GridItem.name]: GridItem,
        [Image.name]: Image,
        [Row.name]: Row,
        [Col.name]: Col,
        [GoodsAction.name]: GoodsAction,
        [GoodsActionIcon.name]: GoodsActionIcon,
        [GoodsActionButton.name]: GoodsActionButton,
        UsedCarListItem,
        UsedCarOrderInfo,
        ItemTabs
    },
    data() {
        return {
            id: null,
            data: {
                used_car_shop: {
                    servers: [],
                    versions: []
                }
            },
            loading: false,
        }
    },
    mounted() {
        this.id = this.$route.params.id
        this.$refs.order.show(this.id)
    },
    methods: {
        getUsedCarData(id) {
            var that = this
            this.axios.get(UsedCarShopApi + id + '/').then((ret) => {
                console.log(ret)
                that.data = ret
                that.$refs.itemTabs.refresh(that.data)
            })
        },
        // getData() { // 订单信息
        //     var that = this
        //     console.log('get data')
        //     console.log(UsedCarOrderApi + that.id + '/')
        //     this.axios.get(UsedCarOrderApi + that.id + '/').then((ret) => {
        //         console.log(ret)
        //         // that.used_car = {
        //         //     id: ret.usdecar,
        //         //     title: ret.usedcar_title,
        //         //     licensing_date: ret.licensing_date,
        //         //     img_url: ret.img_url,
        //         //     driven_distance: ret.driven_distance,
        //         //     area_name: ret.area_name,
        //         //     discharge_standard: ret.discharge_standard,
        //         //     used_car_shop: {
        //         //         server_amount: ret.shop_server_amount
        //         //     }
        //         // }
        //         that.order = ret
        //         // that.$refs.itemTabs.refresh(that.data)
        //     })
        // },
        getOrderInfo(order) {
            console.log('getorderinfo')
            console.log(order)
            this.getUsedCarData(order.usedcar)
        },
        onClickLeft() {

        },
        onTel() {

        },
        onShare() {

        },
        onFavorite() {

        },
        onOrder() {

        }
    }
}
</script>

<style>
.used-car-item {

}
</style>
